import { render, staticRenderFns } from "./CoText.vue?vue&type=template&id=7fe06df3&scoped=true&"
import script from "./CoText.vue?vue&type=script&lang=ts&"
export * from "./CoText.vue?vue&type=script&lang=ts&"
import style0 from "./CoText.vue?vue&type=style&index=0&id=7fe06df3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe06df3",
  null
  
)

export default component.exports